import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../assets/img/rili.png'


const _hoisted_1 = { class: "account" }
const _hoisted_2 = { class: "content_1 flex-n fac" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "name flex-1" }
const _hoisted_5 = { class: "content_2" }
const _hoisted_6 = { class: "flex-n fac con_1" }
const _hoisted_7 = { class: "title flex-1" }
const _hoisted_8 = { class: "flex-n fac con_2" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "ml-30 w-full" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = { class: "flex-n fje mt-20 w-full" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "box flex-n fac" }
const _hoisted_18 = { class: "num" }
const _hoisted_19 = { class: "num" }
const _hoisted_20 = { class: "num" }
const _hoisted_21 = { class: "company" }
const _hoisted_22 = { class: "btn-area flex-n fjc mt-30" }
const _hoisted_23 = ["href"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "content_3" }

import {ref,onMounted,watch} from "vue";
import {useRouter} from "vue-router";
import weChatApi from "@/utils/Api/WeChat";
import weChatObituaryApi from "@/utils/Api/WeChatObituary";
import commMethods from "@/assets/ts/common";
import store from "@/store";

export default /*@__PURE__*/_defineComponent({
  __name: 'account',
  setup(__props) {


const checked = ref(false);
const router=useRouter();

onMounted(()=>{
  document.title='个人账户';

  //
  // if(commMethods.getStorage('info')){
  //   // getData();
  //   info.value=commMethods.getStorage('info');
  //   getObituaryList();
  //   commMethods.getTicket(['downloadVoice']);
  // }

})


const obituaryList=ref([]);
const getObituaryList=()=>{
  weChatApi.getObituaryUserList().then(res=>{
    console.log('讣告信息',res,res.data?.[0])
    obituaryList.value=res.data;
    obuituaryId.value=res.data?.[0].obituaryId;
    onRefresh();
  })
}
const info=ref({})
// const getData=()=>{
//   weChatApi.getWeChatUserDetail().then(res=>{
//     console.log('个人信息',res)
//     info.value=res.data;
//   }).finally(()=>{
//     store.state.refreshInfo=false;
//   })
// }
watch(()=>store.state.refreshInfo,(newval)=>{
  // if(newval){
  //   getData();
  //
  // }
  if(commMethods.getStorage('info')){
    // getData();
    info.value=commMethods.getStorage('info');
    getObituaryList();
    commMethods.getTicket(['downloadVoice']);
  }
},{immediate:true})
const infoList=ref([]);

const refreshing = ref(false);

const pageNo = ref(0);
const refresh = ref(false);
const loading = ref(false);
const finished = ref(false);
const onRefresh = () => {
  pageNo.value = 0;
  infoList.value = [];
  refreshing.value = false;
  // 清空列表数据
  finished.value = false;
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true;
  getDeathinfoSacrificialDayPage();
};
const obuituaryId=ref('');
const onChange=(index:number)=>{
  console.log(index)
  obuituaryId.value=obituaryList.value?.[index]?.obituaryId;
  onRefresh();
}
const getDeathinfoSacrificialDayPage=()=>{
  pageNo.value++;
  weChatApi.deathList(pageNo.value,{obuituaryId:obuituaryId.value}).then(res=>{
    console.log('祭日提醒',res)
    if(res.data)
    infoList.value = infoList.value.concat(res.data.data || []);
    if (infoList.value.length >= res.data?.dataCount) {
      finished.value = true;
    }
  }).finally(() => {
    loading.value = false;
    // refresh.value = false;
    finished.value = true;
  })
}
const changeIsRelease=(id:string,isrelease:boolean)=>{
  weChatObituaryApi.updateSysObituaryRelease({
    id,
    isrelease
  }).then(res=>{
    console.log(res)
  })
}
const gotoPage=(path:string)=>{
  router.push(path);

}


return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_switch = _resolveComponent("van-switch")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: "个人账户",
      fixed: "",
      placeholder: ""
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: info.value?.headimg
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, _toDisplayString(info.value?.nickname), 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (gotoPage('/luckyday')))
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("img", { src: _imports_0 }, null, -1),
          _createTextVNode("吉日查询")
        ]))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_swipe, {
          class: "swipe",
          "indicator-color": "blue",
          onChange: onChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(obituaryList.value, (item) => {
              return (_openBlock(), _createBlock(_component_van_swipe_item, {
                class: "swipe-item",
                key: item.obituaryId
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.obituaryTitle), 1),
                    _createVNode(_component_van_switch, {
                      modelValue: item.isrelease,
                      "onUpdate:modelValue": ($event: any) => ((item.isrelease) = $event),
                      onChange: (e)=>changeIsRelease(item.obituaryId,e)
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: item.obituaryImg
                    }, null, 8, _hoisted_9),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, "发告人：" + _toDisplayString(item.obituarySignature), 1),
                      _createElementVNode("div", _hoisted_12, "发布日期：" + _toDisplayString(item.releaseDate), 1),
                      _createElementVNode("div", _hoisted_13, [
                        _createTextVNode("浏览量：" + _toDisplayString(item.viewTotal||0), 1),
                        _createElementVNode("span", null, "转发量：" + _toDisplayString(item.shareTotal||0), 1)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("button", {
                          class: "btn",
                          onClick: ($event: any) => (gotoPage('/clientcreate?id='+item.obituaryId))
                        }, "编辑", 8, _hoisted_15),
                        _createElementVNode("button", {
                          class: "btn ml-20",
                          onClick: ($event: any) => (gotoPage('/previews?id='+item.obituaryId))
                        }, "预览", 8, _hoisted_16)
                      ])
                    ])
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label_content" }, "云祭祀灵堂", -1)),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(item.burningIncenseTotal||0), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text" }, "燃香", -1))
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(item.paytributeTotal||0), 1),
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text" }, "进贡", -1))
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(item.memorialHallSweep||0), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text" }, "清扫", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, _toDisplayString(item.companyName) + "全程为你提供服务", 1),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("a", {
                      href: 'tel:'+item.contactPhone
                    }, "致电商家", 8, _hoisted_23),
                    _createElementVNode("button", {
                      style: {"margin-left":"3rem"},
                      onClick: ($event: any) => (gotoPage(`/serviceevaluation?companyId=${item.companyId}&obituaryId=${item.obituaryId}`))
                    }, "服务商评价", 8, _hoisted_24)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_25, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title" }, "祭日列表", -1)),
        _createVNode(_component_van_pull_refresh, {
          modelValue: refreshing.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((refreshing).value = $event)),
          onRefresh: onRefresh
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_list, {
              loading: loading.value,
              "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((loading).value = $event)),
              finished: finished.value,
              "finished-text": "没有更多了",
              "immediate-check": false,
              onLoad: getDeathinfoSacrificialDayPage
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infoList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_van_cell, {
                    title: item.callrelation+item.deceasedname+item.sacrificialdayname,
                    "is-link": "",
                    value: item.sacrificialDayDateExt,
                    key: item.id,
                    onClick: ($event: any) => (gotoPage('/festivaldetail?id='+item.id))
                  }, null, 8, ["title", "value", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["loading", "finished"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_van_tabbar, {
      route: "",
      fixed: "",
      placeholder: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tabbar_item, {
          replace: "",
          to: "/",
          icon: "apps-o"
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode("相关讣告")
          ])),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, {
          replace: "",
          to: "/memoriallist",
          icon: "notes-o"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("纪念堂管理")
          ])),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})